import {RefObject, useEffect} from 'react'

///////////////////////////////////////////////////////////////////////////////

export const useFocusOut = (
  ref: RefObject<HTMLElement>,
  callback: () => void,
) => {
  useEffect(() => {
    const cont = ref.current
    let prevented = false

    const onMouseDown = (e) => {
      if (cont?.contains(e.target)) {
        prevented = true
      }
    }

    const onMouseUp = (e) => {
      if (prevented) {
        prevented = false
      }
    }

    const onFocusOut = (e) => {
      setTimeout(() => {
        if (cont && !cont.contains(document.activeElement) && !prevented) {
          callback()
        }
      })
    }

    cont?.addEventListener('mousedown', onMouseDown)
    cont?.addEventListener('mouseup', onMouseUp)
    cont?.addEventListener('focusout', onFocusOut)

    return () => {
      cont?.removeEventListener('mousedown', onMouseDown)
      cont?.removeEventListener('mouseup', onMouseUp)
      cont?.removeEventListener('focusout', onFocusOut)
    }
  }, [callback])
}
